/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button } from "antd-mobile";
import { FormattedMessage } from "react-intl";
import styled from "styled-components";
import Theme from "../../../utils/Theme";
import "./index.css";

const StyledContainer = styled.div`
  background: white;
  height: 100%;
  width: 100%;
  display: flex;
  overflow-x: hidden;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const StyledBannerContainer = styled.div`
  width: 100%;
  height: 50%;
  background-image: url(${require("../../../assets/visitor_top_banner.png")});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  overflow-x: hidden;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
`;

const StyledHeadingTitle = styled.div`
  max-width: 360px;
  width: 85%;
  color: white;
  font-weight: bold;
  font-size: 2.1em;
  margin-bottom: 20px;
  line-height: 1em;
`;

const StyledHeadingSubtitle = styled.div`
  max-width: 360px;
  width: 80%;
  color: white;
  font-size: 1.05em;
  margin-bottom: 25px;
`;

const StyledContentContainer = styled.div`
  width: 100%;
  height: 50%;
  background-image: url(${require("../../../assets/visitor_bottom_banner.png")});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const StyledContentTitle = styled.div`
  max-width: 360px;
  width: 80%;
  color: grey;
  line-height: 1.4em;
  font-size: 1.05em;
`;

const StyledRoundedButton = styled(Button)`
  width: 80%;
  && {
    cursor: pointer;
    font-size: 1em !important;
    border-radius: 25px !important;
    color: white !important;
  }
`;

const StyledSignUpButton = styled(StyledRoundedButton)`
  margin-top: 25px;
  && {
    background-color: ${Theme.PrimaryColor};
  }
`;

const StyledLoginpButton = styled(StyledRoundedButton)`
  margin-top: 5px;
  && {
    background-color: ${Theme.TertiaryColor};
  }
`;

class VisitorSection extends Component {
  render() {
    const { history } = this.props;

    return (
      <StyledContainer>
        <StyledBannerContainer>
          <StyledHeadingTitle>
            <FormattedMessage
              id="visitor.heading.title"
              defaultMessage="Be our member now!"
              description="Visitor Heading Title"
            />
          </StyledHeadingTitle>
          <StyledHeadingSubtitle>
            <FormattedMessage
              id="visitor.heading.subtitle"
              defaultMessage="Enjoy the nice food with cashless payment."
              description="Visitor Heading Subtitle"
            />
          </StyledHeadingSubtitle>
        </StyledBannerContainer>
        <StyledContentContainer>
          <StyledContentTitle>
            <FormattedMessage
              id="visitor.content.subtitle"
              defaultMessage="Create your own eOrder account to top up your credits to the wallet & enjoy benefits too!"
              description="Visitor Content Title"
            />
          </StyledContentTitle>
          <StyledSignUpButton
            activeStyle={{ backgroundColor: Theme.ActivePrimary }}
            onClick={() => history.push("/register")}
          >
            <FormattedMessage
              id="auth.signup.title"
              defaultMessage="Sign Up"
              description="Signup title button at auth page"
            />
          </StyledSignUpButton>
          <StyledLoginpButton
            activeStyle={{ backgroundColor: Theme.ActiveTertiary }}
            onClick={() => history.push("/auth/login")}
          >
            <FormattedMessage
              id="auth.login.title"
              defaultMessage="Login"
              description="Login title button at auth page"
            />
          </StyledLoginpButton>
        </StyledContentContainer>
      </StyledContainer>
    );
  }
}

VisitorSection.propTypes = {
  intl: PropTypes.object,
  showNavbar: PropTypes.func.isRequired,
  showTabbar: PropTypes.func.isRequired,
  navbarConfig: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
};

export default VisitorSection;



// WEBPACK FOOTER //
// ./src/containers/ProfilePage/VisitorSection/index.js